import { useAppSelector } from '@/hooks/use-app-selector'
import { deleteTemplate } from '@/services/scenarioBuilder.service'
import {
  setSelectedReportTemplate,
  toggleDeleteReportTemplateModalOpened,
  toggleIsReloadingReportTemplateGrid,
} from '@/states/scenarioBuilder.slice'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@mui/material'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import LoadingButton from '../Shared/LoadingButton'

export const DeleteScenarioModal: React.FC = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const selectedReportTemplate = useAppSelector(
    (s) => s.scenarioBuilder.selectedReportTemplate,
  )
  const isDeleteReportTemplateModalOpened = useAppSelector(
    (s) => s.scenarioBuilder.isDeleteReportTemplateModalOpened,
  )
  // Ideally, this popup should not open until template is selected
  if (!selectedReportTemplate) return null

  const deleteScenarioConfirmationPopup = async () => {
    setLoading(true)
    try {
      const response = await deleteTemplate(
        selectedReportTemplate?.reportType,
        selectedReportTemplate?.id,
      )
      // Handle success
      if (response.success === true) {
        dispatch(setSelectedReportTemplate(response.data))
        toast.success(
          `Template "${selectedReportTemplate?.name}" successfully deleted`,
        )
        dispatch(toggleIsReloadingReportTemplateGrid())
        handleClose()
      } else {
        toast.error('Something went wrong')
      }
    } catch (error) {
      console.error('Error deleting scenario template:', error)
    } finally {
      setLoading(false)
    }
  }
  const handleClose = () => {
    dispatch(toggleDeleteReportTemplateModalOpened(false))
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth='xs'
        open={isDeleteReportTemplateModalOpened}
        onClose={handleClose}
        aria-labelledby='max-width-dialog-title'
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <Divider />
        <DialogContent>
          Are you sure you want to delete
          <strong style={{ marginInline: 5 }}>
            {selectedReportTemplate?.name}
          </strong>
          scenario template ?
        </DialogContent>
        <Divider />
        <DialogActions>
          <LoadingButton
            loading={loading}
            onClick={deleteScenarioConfirmationPopup}
            color='error'
          >
            Delete
          </LoadingButton>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
